import React from 'react';
import { createPortal } from 'react-dom';
import { BracketSheet } from './BracketSheet';

// Print-only copy of the sheets mounted on <body>, so window.print()
// (header button or Ctrl+P) outputs crisp vector pages at exact paper size.
export const BracketPrintPortal = ({ layout, sheetProps, sheetRefs }) => {
  const { wIn, hIn } = layout.page;
  const css = `#bracket-print-root{display:none}
@media print{
  @page{size:${wIn}in ${hIn}in;margin:0}
  html,body{margin:0!important;padding:0!important;background:#fff!important}
  body > *:not(#bracket-print-root){display:none!important}
  #bracket-print-root{display:block!important}
  #bracket-print-root svg{width:${wIn}in;height:${(hIn - 0.02).toFixed(2)}in;break-after:page;page-break-after:always}
  #bracket-print-root svg:last-child{break-after:auto;page-break-after:auto}
  #bracket-print-root *{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
}`;
  return createPortal(
    <div id="bracket-print-root" aria-hidden="true">
      <style x-excluded="true">{css}</style>
      {layout.geom.viewports.map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <BracketSheet key={i} ref={sheetRefs ? (el) => { sheetRefs.current[i] = el; } : undefined} layout={layout} index={i}
          width={`${wIn}in`} height={`${hIn}in`} {...sheetProps} onSelect={null} noIds />
      ))}
    </div>,
    document.body,
  );
};
